export default "__VITE_ASSET__7e81c321__"